import {
  EventReportOptions,
  PAST_MONTH_OPTION,
  PAST_WEEK_OPTION,
  YESTERDAY_OPTION,
} from '@contexts/event-report/event-report-context.type';
import moment from 'moment';

export const getDatetimesFromToValues = (datimeOption: Omit<EventReportOptions, 'selectRange'>) => {
  const from = moment().startOf('day');
  const to = moment().endOf('day');
  if (datimeOption === YESTERDAY_OPTION) {
    return {
      from: moment().subtract(1, 'days').startOf('day'),
      to: moment().subtract(1, 'days').endOf('day'),
    };
  }
  if (datimeOption === PAST_WEEK_OPTION) {
    return {
      from: moment().subtract(1, 'weeks').startOf('day'),
      to,
    };
  }
  if (datimeOption === PAST_MONTH_OPTION) {
    return {
      from: moment().subtract(1, 'months').startOf('day'),
      to,
    };
  }

  return { from, to };
};
